import SubscriptionManagement from "../view/SubscriptionManagement";
import SubscriptionScheme from "../view/SubscriptionScheme";
import LicenseManagement from '../view/LicenseManagement';
import TocSubscriptionManagement from "../view/TocSubscriptionManagement";
import TopupManagement from "../view/TopupManagement";
import EquityRecord from "../view/EquityRecord";

import HomeIcon from "../assets/首页.svg";
import ProjectManagementIcon from "../assets/项目管理.svg";
import BusinessManagement from "../view/BusinessManagement";
import { PlanList, AuditList } from "../view/TopupPlanManagement";

const routers = [
  {
    menu_url: "/personalEnterprise",
    element: <SubscriptionManagement personalEnterprise={true}> </SubscriptionManagement>,
    open_mode: "CURRENT_PAGE",
    menu_name: "个人订阅管理",
    icon: HomeIcon,
  },
  {
    menu_url: "/subscriptionManagement",
    element: <SubscriptionManagement> </SubscriptionManagement>,
    open_mode: "CURRENT_PAGE",
    menu_name: "企业订阅管理",
    icon: HomeIcon,
  },
  {
    menu_url: "/subscriptionScheme",
    element: <SubscriptionScheme> </SubscriptionScheme>,
    open_mode: "CURRENT_PAGE",
    menu_name: "订阅方案",
    icon: ProjectManagementIcon,
  },
  {
    menu_url: "/licenseManagement",
    element: <LicenseManagement> </LicenseManagement>,
    open_mode: "CURRENT_PAGE",
    menu_name: "产品许可",
    icon: ProjectManagementIcon,
  },
  {
    menu_url: "/businessManagement",
    element: <BusinessManagement></BusinessManagement>,
    open_mode: "CURRENT_PAGE",
    menu_name: "企业管理",
    icon: ProjectManagementIcon,
  },
  {
    menu_url: "/tocIndivSubs",
    element: (
      <TocSubscriptionManagement routeMode="personal">
      </TocSubscriptionManagement>
    ),
    open_mode: "CURRENT_PAGE",
    menu_name: "TOC个人订阅",
    icon: HomeIcon,
  },
  {
    menu_url: "/tocCoSubs",
    element: (
      <TocSubscriptionManagement routeMode="enterprise">
      </TocSubscriptionManagement>
    ),
    open_mode: "CURRENT_PAGE",
    menu_name: "TOC企业订阅",
    icon: HomeIcon,
  },
  {
    menu_url: "/topupMgt",
    element: <TopupManagement />,
    open_mode: "CURRENT_PAGE",
    menu_name: "充值管理",
    icon: ProjectManagementIcon,
  },
  {
    menu_url: "/equityRec",
    element: <EquityRecord />,
    open_mode: "CURRENT_PAGE",
    menu_name: "权益记录",
    icon: ProjectManagementIcon,
  },
  {
    menu_url: "/topupPlanMgt",
    element: <PlanList />,
    menu_name: "方案管理",
    open_mode: "CURRENT_PAGE",
    icon: ProjectManagementIcon,
  },
  {
    menu_url: "/topupPlanAudit",
    element: <AuditList />,
    menu_name: "方案审核",
    open_mode: "CURRENT_PAGE",
    icon: ProjectManagementIcon,
  }
];

export default routers;
